import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { IonicModule } from '@ionic/angular';

import { FullScreenImageComponent } from './full-screen-image.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    LazyLoadImageModule,
  ],
  declarations: [FullScreenImageComponent],
  exports: [FullScreenImageComponent],
})
export class FullScreenImageComponentModule {}
